'use client';

import { use } from 'react';

import { useSearchParams } from 'next/navigation';

import { resolveLegacyBrand } from '../../Utils/ResolveLegacyBrand/ResolveLegacyBrand';
import type { LegacyBrand } from '../../Utils/ResolveLegacyBrand/ResolveLegacyBrand.types';
import { LegacyBrandBanner } from './LegacyBrandBanner';
import type { LegacyBrandBannerMessages } from './LegacyBrandBanner.messages';

const ANNOUNCEMENT_KEY: Record<LegacyBrand, keyof LegacyBrandBannerMessages> = {
  buyacar: 'buyacarAnnouncement',
  heycar: 'heycarAnnouncement',
  'heycar-de': 'heycarDeAnnouncement',
  'heycar-fr': 'heycarFrAnnouncement',
  'heycar-es': 'heycarEsAnnouncement',
  honestjohn: 'honestJohnAnnouncement',
};

const CTA_LINK: Record<LegacyBrand, string> = {
  heycar: '/looking-for-heycar-welcome-to-drive',
  'heycar-de': '/looking-for-heycar-welcome-to-drive',
  'heycar-fr': '/looking-for-heycar-welcome-to-drive',
  'heycar-es': '/looking-for-heycar-welcome-to-drive',
  buyacar: '/looking-for-buyacar-welcome-to-drive',
  honestjohn: '/looking-for-honestjohn-welcome-to-drive',
};

export const LegacyBrandBannerInner = ({
  stringsPromise,
}: {
  stringsPromise: Promise<LegacyBrandBannerMessages>;
}) => {
  const strings = use(stringsPromise);
  const searchParams = useSearchParams();
  const brand = resolveLegacyBrand(searchParams.get('from'));
  const bannerCopy = brand
    ? {
        announcement: strings[ANNOUNCEMENT_KEY[brand]],
        ctaText: strings.ctaText,
        ctaHref: CTA_LINK[brand],
      }
    : null;

  return <LegacyBrandBanner brand={brand} bannerCopy={bannerCopy} />;
};
